export default __webpack_public_path__ + "static/media/Background_00063.bf75c507.png";